import {DepartmentField} from './department-field';
import {EmailField} from './email-field';
import {FaxField} from './fax-field';
import {NameField} from './name-field';
import {NameKanaField} from './name-kana-field';
import {PasswordConfirmField} from './password-confirm-field';
import {PasswordField} from './password-field';
import {PhoneNumberField} from './phone-number-field';

export const contactPersonInfoFields = {
  departmentField: DepartmentField,
  emailField: EmailField,
  faxField: FaxField,
  nameField: NameField,
  nameKanaField: NameKanaField,
  passwordConfirmField: PasswordConfirmField,
  passwordField: PasswordField,
  phoneNumberField: PhoneNumberField,
};
